import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {CLIENT_JOURNEY_STATE_IS_LOADING} from '/enum/clientJourneyState.enum';
import {FIRST_TAB, PRE_JOURNEY} from '/enum/clientJourneyTasks.enum';
import {
  fetchClientJourneyTask,
  setClientJourneyState,
  setClientJourneyTasks,
} from '/redux/action/client.action';
import {
  clientJourneyTasksByType,
  filteredClientJourneyTasks,
  hasPreJourneyTasks,
} from '/redux/selector/client.selector';
import {allReportData} from '/redux/selector/report.selector';
import {withProps} from '/util/selector.util';

import {PreJourney} from './PreJourney';

export default connect(
  createStructuredSelector({
    hasPreJourneyTasks,
    preJourneyTasks: withProps({type: PRE_JOURNEY})(clientJourneyTasksByType),
    preJourneyInitialTasks: withProps({filter: FIRST_TAB})(
      filteredClientJourneyTasks,
    ),
    reportData: allReportData,
  }),
  dispatch => ({
    fetchClientJourneyTask: ({clientId, type, task, reportData}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(fetchClientJourneyTask({clientId, type, task, reportData})),
    setClientJourneyTasks: ({clientId, type, tasks}: any) =>
      // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
      dispatch(setClientJourneyTasks({clientId, type, tasks})),
    setClientJourneyState: ({clientId, type, stateName, stateValue}: any) =>
      dispatch(
        // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
        setClientJourneyState({
          clientId,
          type,
          stateName,
          stateValue,
        }),
      ),
  }),
  (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    fetchClientJourneyTask: ({task}: any) => {
      const {clientId} = ownProps;
      const {reportData} = stateProps;

      return dispatchProps.fetchClientJourneyTask({
        type: PRE_JOURNEY,
        clientId,
        task,
        reportData,
      });
    },
    setClientJourneyTasks: ({tasks}: any) => {
      const {clientId} = ownProps;
      return dispatchProps.setClientJourneyTasks({
        type: PRE_JOURNEY,
        clientId,
        tasks,
      });
    },
    setClientJourneyState: () => {
      const {clientId} = ownProps;
      return dispatchProps.setClientJourneyState({
        clientId,
        type: PRE_JOURNEY,
        stateName: CLIENT_JOURNEY_STATE_IS_LOADING,
        stateValue: true,
      });
    },
  }),
)(PreJourney);
